import React, { useState, useEffect } from "react";
import Projects from "../components/User/Projects/Projects";
import Gallery from "../components/User/Gallery/Gallery";
import OurWorkPage from "./OurWorkPage";
import Hero from "../components/User/Hero/Hero";
import Footer from "../components/User/Footer/Footer";
import News from "../components/User/News/News";
import AboutUs from "../components/User/AboutUs/AboutUs";
import { img, imgURL } from "../components/Config";
import { getAllData, getAllDataWithFlag, getThemeData, getTypologyData } from "../services/CommonService";
import Shimmer from "../components/Shimmer/Shimmer";
import moment from 'moment';
import ThemeTypoModal from "../components/Admin/Dashboard/Project/ThemetypoModal";
import OurWork from "../components/User/OurWork/OurWork";

function HomePage() {
  const [slides, setSlides] = useState([]);
  const [carouselData, setCarouselData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [aboutData, setAboutData] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [galleryData, setGalleryData] = useState([]);
  const [newsData, setNewsData] = useState([]);
  const [fetchedFlags, setFetchedFlags] = useState(new Set());
  const [isFetching, setIsFetching] = useState(false);
  const fetchedFlagsRef = React.useRef(new Set());
  const sectionRefs = Array.from({ length: 12 }, () => React.createRef());
  const [flags, setFlags] = useState();
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [selectionType, setSelectionType] = useState(null);

  useEffect(() => {
    fetchData(1);
    fetchData(3);
    fetchData(11);
  }, []);

  useEffect(() => {
    // fetchData();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const sectionIndex = Number(entry.target.dataset.index);
            const flag = sectionIndex + 1;
            setFlags(flag)
            if (!fetchedFlagsRef.current.has(flag) && flag <= 12) {
              fetchData(flag);
            }
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    sectionRefs.forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });

    return () => {
      sectionRefs.forEach((ref) => {
        if (ref.current) observer.unobserve(ref.current);
      });
    };
  }, [fetchedFlags]);

  const fetchData = async (flag) => {
    if (fetchedFlagsRef.current.has(flag)) return;
    fetchedFlagsRef.current.add(flag);
    setFetchedFlags(new Set(fetchedFlagsRef.current));
    setIsFetching(true);
    setLoading(true);
    try {
      const response = await getAllDataWithFlag(flag);
      if (flag === 3) localStorage.setItem('lookup', JSON.stringify(response?.data?.mstlookup));
      if (flag === 11) localStorage.setItem('StateMaster', JSON.stringify(response?.data));
      if (flag === 2) setAboutData(response?.data?.diversionary_trajectory);
      if (flag === 10) setGalleryData(response?.data?.gallery);
      if (flag === 12) {
        // const newsData = response?.data?.news.filter((r)=> r.end_date <= moment().for)
        const filteredNewsData = response?.data?.news?.filter((m) => m.is_deleted == 1);
        setNewsData(filteredNewsData)
      }
      if (flag === 1) {
        const imageSlides = response?.data?.banners?.map(
          (item) => imgURL + item?.image_path
        );
        const dynamicOverlayContent = response?.data?.banners?.map((item) => {
          return (
            <div key={item.id} className="content-wrapper">
              {item.banner_desc && (
                <p
                  className="subtitle"
                  dangerouslySetInnerHTML={{ __html: item.banner_desc }}
                />
              )}
              {item.banner_title && (
                <h2 className="title">{item?.banner_title}</h2>
              )}
              <button className="explore-btn">Explore</button>
              {/* Dynamic content based on API response */}
            </div>
          );
        });
        setSlides(imageSlides || ['/assets/images/bannerDefault.jpg']);
        setCarouselData(dynamicOverlayContent);
        localStorage.setItem('banners', JSON.stringify(response?.data?.banners))
      }
      if (flag === 5) setProjectData(response?.data?.project);
      const typology = await getTypologyData();
      if (typology) localStorage.setItem('typologyData', JSON.stringify(typology?.data));
      const theme = await getThemeData();
      if (theme) localStorage.setItem('themeData', JSON.stringify(theme?.data));
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err?.response?.data?.message || err?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
      setSlides(img || ['/assets/images/bannerDefault.jpg']);
      setCarouselData([
        <div key="1" className="content-wrapper">
          <p className="subtitle">
            Aims at establishing a groundwater management agenda in India.
          </p>
          <h2 className="title">ACWADAM is a Not for Profit Organisation</h2>
          <button className="explore-btn">Explore</button>
        </div>,
      ]);
    } finally {
      setIsFetching(false);
      setLoading(false);
    }
  };

  const handleOpenModal = (data, type) => {
    setSelectedData(data);
    setShowViewModal(true);
    setSelectionType(type)
  };
  return (
    <>
      <div ref={sectionRefs[0]} data-index="0">
        {!loading && slides?.length ? (
          <Hero slides={slides} carouselData={carouselData} />
        ) : (<Shimmer />)}</div>
      <div ref={sectionRefs[1]} data-index="1">
        {!loading && aboutData.length ? <AboutUs aboutData={aboutData} /> : <Shimmer />}</div>
      <div ref={sectionRefs[11]} data-index="11">
        {!loading && newsData?.length ? <News newsData={newsData} /> : <Shimmer />}
      </div>
      <div ref={sectionRefs[5]} data-index="5">
        {fetchedFlagsRef.current.has(6) ? <OurWork onMapClick={handleOpenModal} /> : <Shimmer />}
      </div>
      {/* <div ref={sectionRefs[4]} data-index="4">
        {!loading && projectData?.length ? <Projects project={projectData} /> : <Shimmer />}</div> */}
      <div ref={sectionRefs[9]} data-index="9">
        {!loading && galleryData?.length ? <Gallery galleryData={galleryData} /> : <Shimmer />}</div>
      {/* <Footer /> */}
      {showViewModal && (
        <ThemeTypoModal selectionType={selectionType} selectedData={selectedData} setShowViewModal={setShowViewModal} />
      )}
    </>
  );
}

export default HomePage;
